import { MODEL_PLACEHOLDER } from 'models/constants/placeholder'
import { mapValuesObjectUtil } from 'packages/src'

/**
 * Creates a pojo instance.
 * @param  {string} className
 * @param  {Object} [data={}]
 * @returns {Object}
 */
function createModelUtil (className, data = {}) {
  const attribute = MODEL_PLACEHOLDER[className]
  return {
    ...mapValuesObjectUtil(attribute, () => ''),
    className,
    ...data
  }
}

export {
  createModelUtil
}
